// @flow
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { showAlert } from 'actions/app';
import { EntityRoutes } from 'routes/constants';
import { addToSearchProject } from 'services/searchProjects';
import strings from 'strings';
import type { AddToSearchProjectDrawerProps } from 'types/app';
import FPButtonBuilder from 'UI/components/molecules/FPButtonBuilder';
import ProjectList from 'UI/components/organisms/ProjectList';
import { buildCloseAndSaveButtonDefinition } from 'UI/components/templates/FPDrawer';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';

import { useStyles } from './styles';

const { addItemsToSearchProject: formCopies } = strings.searchProjects.forms;

const AddToSearchProjectDrawer = ({
  bulkId = null,
  createdFrom = 'other',
  currentSearchProjectId,
  extraPayloadData = null,
  itemsToAdd,
  moveCopiedItems,
  onAddItemsToSP,
  onClose,
  onRefreshSearchProjectsTab,
  queryParams,
  shouldRedirectToSearchProjectPreview = true
}: AddToSearchProjectDrawerProps) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const classes = useStyles();

  const [selectedSearchProjectId, setSelectedSearchProjectId] = useState(null);
  const [uiState, setUiState] = useState({
    isSaving: false,
    isSuccess: false
  });

  const handleAddToSearchProjectClick = searchProjectId =>
    setSelectedSearchProjectId(searchProjectId);

  const handleSubmit = async e => {
    e.preventDefault();
    setUiState({ isSaving: true, isSuccess: false });
    const { alert, success } = await addToSearchProject({
      bulkId,
      createdFrom,
      currentSearchProjectId,
      extraPayloadData,
      itemsToAdd,
      moveCopiedItems,
      queryParams,
      selectedSearchProjectId
    });
    dispatch(showAlert(alert));
    setUiState({ isSaving: false, isSuccess: success });

    if (!success) return;

    onAddItemsToSP && onAddItemsToSP();
    !shouldRedirectToSearchProjectPreview &&
      onRefreshSearchProjectsTab &&
      onRefreshSearchProjectsTab(false);

    shouldRedirectToSearchProjectPreview &&
      setTimeout(() => {
        history.push(EntityRoutes.SearchProjectsPreview.replace(':id', selectedSearchProjectId));
      }, 1);
  };

  const buttonDefinitions = buildCloseAndSaveButtonDefinition({
    onClose,
    isSaveDisabled: !selectedSearchProjectId || uiState.isSaving,
    isSaving: uiState.isSaving
  });

  return (
    <FPDrawer
      FPDrawerProps={{ open: true, classes: { paper: classes.drawerRoot } }}
      CardHeaderProps={{ title: formCopies.title }}
      ContentWrapperProps={{ onSubmit: handleSubmit, id: 'drawer-form' }}
      ContentWrapper="form"
      onClose={onClose}
      hasPaddingContent={false}
      footer={
        <FPButtonBuilder
          GridContainerProps={{ spacing: 2 }}
          buttonDefinitions={buttonDefinitions}
        />
      }
    >
      <ProjectList
        itemsToAdd={itemsToAdd}
        queryParams={queryParams}
        onRowClick={handleAddToSearchProjectClick}
        createdFrom={createdFrom}
        searchProjectId={currentSearchProjectId}
      />
    </FPDrawer>
  );
};

export default AddToSearchProjectDrawer;
